module.exports = __webpack_public_path__ + "img/lock.229be7af.svg";